import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';

interface Cliente {
  id: number;
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  dataCadastro: Date;
  isEmpresaGestora: boolean;
  cnes: string;
  dataFundacao: Date;
  pessoaNome: string;
  pessoaCpf: string;
  pessoaEmail: string;
  pessoaDataNascimento: Date;
  pessoaTelefone: string;
  endereco: string;
  numero: number;
  bairro: string;
  telefonePrincipal: string;
  telefoneAuxiliar: string;
  telefoneWhatsapp: string;
  site: string;
  email: string;
  funcionamento: string;
  secretariaAtendente: string;
  responsavelNome: string;
  responsavelConselho: string;
  responsavelRegistro: string;
  admNome: string;
  admFuncao: string;
  admCelular: string;
  admEmail: string;
  servicosOfertados: string;
  observacao: string;
  status: string;
  idCidade: number;
}

interface Cidade {
  id: number;
  nome: string;
}

@Component({
  selector: 'app-cadastro-cliente-gestao',
  templateUrl: './cadastro-cliente-gestao.component.html',
  styleUrls: ['./cadastro-cliente-gestao.component.scss']
})
export class CadastroClienteGestaoComponent implements OnInit {
  clienteForm: FormGroup;
  isEditing = false;
  clientes: Cliente[] = [];
  cidades: Cidade[] = [];
  dtOptions: DataTables.Settings = {};

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private modalService: NgbModal,
    private ajax: AjaxService,
    private util: UtilService
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      },
      order: [[0, 'asc']],
      responsive: true
    };
    this.carregarClientes();
    this.carregarCidades();
  }

  createForm() {
    this.clienteForm = this.fb.group({
      nomeFantasia: ['', Validators.required],
      razaoSocial: ['', Validators.required],
      cnpj: ['', Validators.required],
      isEmpresaGestora: [false],
      cnes: [''],
      dataFundacao: [''],
      pessoaNome: [''],
      pessoaCpf: [''],
      pessoaEmail: [''],
      pessoaDataNascimento: [''],
      pessoaTelefone: [''],
      endereco: [''],
      numero: [''],
      bairro: [''],
      telefonePrincipal: [''],
      telefoneAuxiliar: [''],
      telefoneWhatsapp: [''],
      site: [''],
      email: ['', Validators.email],
      funcionamento: [''],
      secretariaAtendente: [''],
      responsavelNome: [''],
      responsavelConselho: [''],
      responsavelRegistro: [''],
      admNome: [''],
      admFuncao: [''],
      admCelular: [''],
      admEmail: ['', Validators.email],
      servicosOfertados: [''],
      observacao: [''],
      idCidade: ['']
    });
  }
 
  carregarClientes() {
    this.util.showLoading();
    this.ajax.get(`${API}Empresa/Empresa`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.clientes = response.data.map((cliente: any) => ({
              id: cliente.id,
              nomeFantasia: cliente.nomE_FANTASIA,
              razaoSocial: cliente.razaoSocial,
              cnpj: cliente.cnpj,
              dataCadastro: new Date(cliente.datA_CADASTRO),
              isEmpresaGestora: cliente.isEmpresaGestora,
              cnes: cliente.cnes,
              dataFundacao: cliente.dataFundacao ? new Date(cliente.dataFundacao) : null,
              pessoaNome: cliente.pessoaNome,
              pessoaCpf: cliente.pessoaCpf,
              pessoaEmail: cliente.pessoaEmail,
              pessoaDataNascimento: cliente.pessoaDataNascimento ? new Date(cliente.pessoaDataNascimento) : null,
              pessoaTelefone: cliente.pessoaTelefone,
              endereco: cliente.endereco,
              numero: cliente.numero,
              bairro: cliente.bairro,
              telefonePrincipal: cliente.telefonePrincipal,
              telefoneAuxiliar: cliente.telefoneAuxiliar,
              telefoneWhatsapp: cliente.telefoneWhatsapp,
              site: cliente.site,
              email: cliente.email,
              funcionamento: cliente.funcionamento,
              secretariaAtendente: cliente.secretariaAtendente,
              responsavelNome: cliente.responsavelNome,
              responsavelConselho: cliente.responsavelConselho,
              responsavelRegistro: cliente.responsavelRegistro,
              admNome: cliente.admNome,
              admFuncao: cliente.admFuncao,
              admCelular: cliente.admCelular,
              admEmail: cliente.admEmail,
              servicosOfertados: cliente.servicosOfertados,
              observacao: cliente.observacao,
              status: cliente.status,
              idCidade: cliente.idCidade
            }));
          } else {
            this.clientes = [];
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar clientes. Tente novamente.");
          console.error('Erro ao carregar clientes:', error);
        }
      });
  }

  carregarCidades() {
    this.util.showLoading();
    this.ajax.get(`${API}Cidade/Cidade`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.cidades = response.data.map((cidade: any) => ({
              id: cidade.id,
              nome: cidade.nome
            }));
          } else {
            this.cidades = [];
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar cidades. Tente novamente.");
          console.error('Erro ao carregar cidades:', error);
        }
      });
  }

  onSubmit() {
    if (this.clienteForm.valid) {
      this.util.showLoading();
      const formData = this.clienteForm.value;
      
      if (formData.id) {
        // Atualizar cliente existente
        this.ajax.put(`${API}Empresa/Empresa/${formData.id}`, formData)
          .subscribe({
            next: () => {
              this.util.closeLoading();
              this.util.toasterShowSuccess("Sucesso", "Cliente atualizado com sucesso!");
              this.isEditing = false;
              this.carregarClientes();
            },
            error: (error) => {
              this.util.closeLoading();
              this.util.toasterShowError("Erro", "Erro ao atualizar cliente. Tente novamente.");
              console.error('Erro ao atualizar cliente:', error);
            }
          });
      } else {
        // Criar novo cliente
        this.ajax.post(`${API}Empresa/Empresa`, formData)
          .subscribe({
            next: () => {
              this.util.closeLoading();
              this.util.toasterShowSuccess("Sucesso", "Cliente cadastrado com sucesso!");
              this.isEditing = false;
              this.carregarClientes();
            },
            error: (error) => {
              this.util.closeLoading();
              this.util.toasterShowError("Erro", "Erro ao cadastrar cliente. Tente novamente.");
              console.error('Erro ao cadastrar cliente:', error);
            }
          });
      }
    }
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (!this.isEditing) {
      this.clienteForm.reset();
    }
  }

  editarCliente(cliente: Cliente) {
    this.isEditing = true;
    this.clienteForm.patchValue(cliente);
  }

  alterarStatus(cliente: Cliente) {
    const novoStatus = cliente.status === 'Ativo' ? 'Inativo' : 'Ativo';
    
    this.util.showLoading();
    this.ajax.put(`${API}Empresa/Empresa/${cliente.id}/status`, { status: novoStatus })
      .subscribe({
        next: () => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Sucesso", `Status do cliente alterado para ${novoStatus}`);
          this.carregarClientes();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao alterar status do cliente. Tente novamente.");
          console.error('Erro ao alterar status do cliente:', error);
        }
      });
  }
} 